import {
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  postRequestWithFiles,
  putRequestWithFiles,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";
import { globalConstants } from "../constants";

//Get all paginated Event list
const getPaginatedEvents = (data) => {
  return postRequest(`/${globalConstants.VERSION}/Event/get`, data, true).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get all paginated public Event list
const getPaginatedPublicEvents = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/Event/get/view`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getPaginatedEventParticipants = (data, eventId) => {
  return postRequest(
    `/${globalConstants.VERSION}/EventParticipant/participants/${eventId}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getPaginatedMyEvents = (data, userId) => {
  return postRequest(
    `/${globalConstants.VERSION}/Event/user/${userId}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

async function addEvent(eventData) {
  return postRequestWithFiles(
    `/${globalConstants.VERSION}/Event`,
    eventData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

const getEventById = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Event/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getParticipantByEmail = (email) => {
  return postRequest(
    `/${globalConstants.VERSION}/User/student`,
    email,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getEventByIdWithDocs = (id) => {
  return getRequest(`/${globalConstants.VERSION}/Event/docs/${id}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};
const validateParticipentsForEvents = (systemUserId, eventId) => {
  return getRequest(
    `/${globalConstants.VERSION}/EventParticipant/validate/${systemUserId}/${eventId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const updateEvent = (formData) => {
  return putRequestWithFiles(
    `/${globalConstants.VERSION}/Event`,
    formData,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

async function updateEventStatusById(id, status) {
  return putRequest(
    `/${globalConstants.VERSION}/Event/updateStatus/${id}/${status}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteEventById(eventId) {
  return deleteRequest(
    `/${globalConstants.VERSION}/Event/${eventId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

//Add center instructor
const addEventParticipant = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/EventParticipant/register`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

async function addParticipantWithPayment(checkoutId) {
  return postRequest(
    `/${globalConstants.VERSION}/EventParticipant/register/${checkoutId}`,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

const exportParticipantData = (gridState, requestType, eventId) => {
  return postRequest(
    `/${globalConstants.VERSION}/EventParticipant/export/participants/${eventId}`,
    gridState
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const cancelPublicEventRegistration = (userId, eventId) => {
  return deleteRequest(
    `/${globalConstants.VERSION}/EventParticipant/public/cancel/${userId}/${eventId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const cancelPrivateEventRegistration = (userId, eventId) => {
  return deleteRequest(
    `/${globalConstants.VERSION}/EventParticipant/private/cancel/${userId}/${eventId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const cancelPublicEventRegistrationByAdmin = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/EventParticipant/admin/public/cancel`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const eventRegistrationwithSavedCard = (data) => {
  return postRequest(
    `/${globalConstants.VERSION}/EventParticipant/savedCard/register`,
    data
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

async function getEventTotalPaymentById(eventId) {
  return getRequest(
    `/${globalConstants.VERSION}/Event/totalPayment/${eventId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const eventService = {
  getPaginatedEvents,
  addEvent,
  deleteEventById,
  getEventById,
  getEventByIdWithDocs,
  updateEvent,
  getPaginatedEventParticipants,
  getParticipantByEmail,
  addEventParticipant,
  exportParticipantData,
  getPaginatedPublicEvents,
  getPaginatedMyEvents,
  cancelPublicEventRegistration,
  cancelPrivateEventRegistration,
  cancelPublicEventRegistrationByAdmin,
  validateParticipentsForEvents,
  updateEventStatusById,
  addParticipantWithPayment,
  eventRegistrationwithSavedCard,
  getEventTotalPaymentById,
};
